import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
	ChangeDetectorRef,
	ChangeDetectionStrategy,
	ViewChildren,
	QueryList,
	OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

import {
	AccountCarrierMapDTO,
	CarrierDTOResponse,
	ContactsTable,
	DATE_MDY,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	ProjectCarrierMapDTO,
	ProjectDTO,
	RestService,
	TruckSearchTable,
	Owner,
	IS_EMPTY,
	GET_CARRIER_BUSINESS_NAME,
	CONTACT_LIST_TABLE,
	IS_EMPTY_LIST,
	BUILD_LANE,
	FORMAT_LOCATION,
} from 'cargo-chief-commons';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { ProjectHelperService } from '@service/projectHelper/project-helper.service';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { CarrierFeedbackService } from '@service/carrierFeedback/carrier-feedback.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { ACCOUNT_TYPE, COPY_TO_CLIPBOARD_MSGS } from '@domain/constants/app-variables';
import { ProductsService } from '@service/products/products.service';
import { UserCarrierMapHelperService } from '@service/userCarrierMapHelper/user-carrier-map-helper.service';
import { SharedService } from '@service/shared/shared.service';
import { CarrierVettingService } from '@service/carrier-vetting/carrier-vetting.service';
import { SHOW_IN_NETWORK_LOGO } from '@shared/utils/in-network';
import { IntegrationService } from '@service/integration/integration.service';
import { Store } from '@ngrx/store';
import { PROJECT_CARRIER_MAP } from '../store/actions/';
import { projectDetailsPageStateKey } from '../store/state';
import { takeUntil } from 'rxjs/operators';
import { Observable, of, take } from 'rxjs';
import { BaseComponent } from '@shared/base/base.component';
import { HaulpayService } from '@service/haulpay/haulpay.service';
import { environment } from '@environment/environment';
import { AllocationStatusDTO } from '@core/services/allocation/allocation.service';

@Component({
	selector: 'app-allocated-carriers',
	templateUrl: './allocated-carriers.component.html',
	styleUrls: ['./allocated-carriers.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllocatedCarriersComponent extends BaseComponent implements OnInit, OnDestroy {
	@Input() projectCarrierMapList: Array<ProjectCarrierMapDTO> = [];
	@Input() selectedProjectCarrierMapIDs: Array<string> = [];
	@Input() isCarrierRatesEnabled: boolean = false;
	@Input() accountCarrierLanes: any = {};
	@Input() projectDTO: ProjectDTO = {} as ProjectDTO;
	@Input() allProjectsList: Array<ProjectDTO> = [];
	@Input() projectsNextPage: boolean = false;
	@Input() isLoadingProjectsList: boolean = false;
	@Input() totalNumberOfProjects = 0;
	@Input() isLoadingAccountCarrierLanes: boolean = false;
	@Input() searchTruckForm: any = null;
	@Input() usersList: Array<Owner> = [];
	@Input() allUsersList: Array<Owner> = [];
	@Input() userCarrierMapList: Array<any> = [];
	@Input() userCarrierMap: any = {};
	isCarrierVettingIntegrationEnabled: boolean;
	@Input() CARRIER_QUALITY_ENABLED!: boolean;
	@Input() carrierAllocationsMap: { [carrierId: string]: AllocationStatusDTO } = {};

	@Output() openFullProfileEvent: EventEmitter<{ projectCarrierMap: any; event: MouseEvent }> =
		new EventEmitter();
	@Output() fireSegmentEvent: EventEmitter<{
		projectId: string;
		carrierId: string;
		cIndex: number;
	}> = new EventEmitter();
	@Output() panelClicked: EventEmitter<{
		projectCarrierMap: ProjectCarrierMapDTO;
		event: MouseEvent;
		cardIndex: number;
		wasExpanded: any;
		shiftKey: any;
	}> = new EventEmitter();
	@Output() editAllocationEvent: EventEmitter<{
		projectCarrierMap: ProjectCarrierMapDTO;
	}> = new EventEmitter();

	@ViewChildren(CdkVirtualScrollViewport) viewports: QueryList<CdkVirtualScrollViewport>;

	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	DATE_MDY = DATE_MDY;
	IS_NOT_EMPTY = IS_NOT_EMPTY;
	COPY_TO_CLIPBOARD_MSGS = COPY_TO_CLIPBOARD_MSGS;
	SHOW_IN_NETWORK_LOGO = SHOW_IN_NETWORK_LOGO;
	GET_CARRIER_BUSINESS_NAME = GET_CARRIER_BUSINESS_NAME;

	step = null;
	selectedMatch: ProjectCarrierMapDTO = null;
	contactList: ContactsTable[] = null;
	isContactsListInitialised: boolean = false;
	accountId: number;
	selectedProjectCarrierMap: Observable<ProjectCarrierMapDTO>;
	ACCOUNT_TYPE = ACCOUNT_TYPE;
	USER_ACCOUNT_TYPE: string = null;
	environment = environment;

	constructor(
		private urlService: UrlService,
		private restService: RestService,
		public utilService: UtilService,
		public cargochief: Cargochief,
		public projectHelperService: ProjectHelperService,
		private segmentWrapper: SegmentWrapperService,
		private carrierFeedbackService: CarrierFeedbackService,
		public accountSettings: AccountSettingsService,
		private router: Router,
		public productsService: ProductsService,
		private userCarrierMapHelperService: UserCarrierMapHelperService,
		private sharedService: SharedService,
		private cd: ChangeDetectorRef,
		public carrierVettingService: CarrierVettingService,
		public haulpayService: HaulpayService,
		public integrationService: IntegrationService,
		private store: Store
	) {
		super();
		this.USER_ACCOUNT_TYPE = this.cargochief.USER_ACCOUNT_TYPE;
		this.isCarrierVettingIntegrationEnabled =
			this.integrationService.isCarrierVettingIntegrationEnabled();
	}

	ngOnInit(): void {
		this.accountId = this.cargochief.ACCOUNT_ID;
	}

	setStep(index: number) {
		this.isContactsListInitialised = false;
		this.step = index;
		this.selectedMatch = this.projectCarrierMapList[index];
		this.populateContactsList();
		this.setSelectedProjectCarrierMap(this.selectedMatch);
		this.isContactsListInitialised = true;

		this.calculateViewportSize();
	}

	matchClosed() {
		this.selectedMatch = null;
		this.setSelectedProjectCarrierMap(this.selectedMatch);
	}

	emitPanelClickedEvent(
		projectCarrierMap: ProjectCarrierMapDTO,
		event: MouseEvent,
		cardIndex: number,
		isCheckCircleClicked: boolean
	) {
		// Prevent Material header's default toggle from racing our state update
		event.preventDefault();
		event.stopPropagation();

		const wasExpanded = this.step === cardIndex;
		const shift = event.shiftKey;

		if (shift) {
			// Shift-mode = multi-select only, never expand
			this.closeAllPannels();
		} else {
			// Single select is always expanded and selected
			if (wasExpanded) {
				// Clicking same expanded panel collapses + deselects
				this.closeAllPannels();
			} else {
				// Clicking another expands only that one
				this.setStep(cardIndex);
			}
		}

		this.panelClicked.emit({ projectCarrierMap, event, cardIndex, wasExpanded, shiftKey: shift });
		this.calculateViewportSize();
	}

	closeAllPannels() {
		this.step = null;
		this.selectedMatch = null;
		this.setSelectedProjectCarrierMap(null);

		this.calculateViewportSize();
	}

	populateContactsList() {
		this.contactList = CONTACT_LIST_TABLE(this.selectedMatch.carrier.contacts);
		if (IS_EMPTY_LIST(this.contactList)) {
			this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.carrier_missing_contact_info, {
				carrier: this.getCarrierInfo(),
			});
		}
	}

	getCarrierInfo() {
		return {
			businessName: this.selectedMatch.carrier.businessName,
			mc: this.selectedMatch.carrier.mc,
			dot: this.selectedMatch.carrier.dot,
			carrierId: this.selectedMatch.carrier.id,
		};
	}

	updateContactsList(updatedList: Array<ContactsTable>) {
		this.contactList = [...updatedList];
	}

	emitOpenFullProfileEventEvent(projectCarrierMap: ProjectCarrierMapDTO, event: MouseEvent) {
		this.router.navigate([], {
			queryParams: {
				fullProfile: 'true',
			},
			queryParamsHandling: 'merge',
		});
		this.openFullProfileEvent.emit({ projectCarrierMap, event });
	}

	async reportDataAction(dataType: string, carrier: CarrierDTOResponse) {
		const capacitySearch: Partial<TruckSearchTable> = {
			businessName: carrier.businessName,
			carrierId: carrier.id,
			firmMc: carrier.mc,
			firmDot: carrier.dot,
			carrierHQ: carrier?.city + ',' + carrier?.state,
			originCity: this.projectDTO?.originCity,
			originState: this.projectDTO?.originState,
			destCity: this.projectDTO?.destCity,
			destState: this.projectDTO?.destState,
			lanePath: BUILD_LANE(
				FORMAT_LOCATION(this.projectDTO?.originCity, this.projectDTO?.originState, null),
				FORMAT_LOCATION(this.projectDTO?.destCity, this.projectDTO?.destState, null),
				this.projectDTO?.equipmentType
			),
			phone: carrier.phone,
			drivers: carrier.drivers,
			trailerTypes: this.projectDTO?.equipmentType,
		};
		await this.carrierFeedbackService.reportDataAction(
			dataType,
			this.searchTruckForm,
			capacitySearch
		);
	}

	getUserIdAssigned(carrierId: string): number {
		const cMap = this.userCarrierMapList.find((c: any) => c.carrierId === carrierId);
		return cMap?.assigneeId;
	}

	setAssignee(user: Owner, carrierId: string) {
		if (!this.utilService.isNullOrUndefined(user)) {
			const cMap = this.userCarrierMapList.find(
				(c: any) => c.carrierId === carrierId
			);
			if (
				this.utilService.isNullOrUndefined(cMap) ||
				(!this.utilService.isNullOrUndefined(cMap) && cMap.assigneeId != user.userId)
			) {
				this.addUserCarrierMap(user, carrierId);
			}
		} else if (
			this.utilService.isNullOrUndefined(user) &&
			!this.utilService.isNullOrUndefined(this.userCarrierMap)
		) {
			const cMap = this.userCarrierMapList.find(
				(c: any) => c.carrierId === carrierId
			);
			if (cMap?.id) {
				this.deleteUserCarrierMap(carrierId, cMap.id);
			}
		}
	}

	addUserCarrierMap(user: Owner, carrierId: string) {
		const payload = this.userCarrierMapHelperService.createPayload(user.userId, carrierId, false);
		const url = this.urlService.userCarrierMap();
		this.restService
			.POST(url, payload)
			.pipe(takeUntil(this.isDestroyed$))
			.subscribe(
				(result) => {
					this.userCarrierMap[carrierId] = user.name;
					this.utilService.showSnackbar('User Assigned.', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
					this.sharedService.sendCarrierAssignedEvent({
						deleted: false,
						carrierId: carrierId,
						assigneeName: user.name,
						userCarrierMap: result.data,
					});
					this.userCarrierMapList = this.userCarrierMapList.filter(
						(cMap: any) => cMap.carrierId != carrierId
					);
					this.userCarrierMapList.push(result.data);
				},
				(error) => {
					this.utilService.showSnackbar(
						'Unable to set Assignee. Please try again.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
				}
			);
	}

	deleteUserCarrierMap(carrierId: string, userCarrierMapId: string) {
		const payload = {
			userCarrierMapIDs: [userCarrierMapId],
		};
		const url = this.urlService.userCarrierMap();
		this.restService
			.DELETE(url, payload)
			.pipe(takeUntil(this.isDestroyed$))
			.subscribe(
				(result) => {
					delete this.userCarrierMap[carrierId];
					this.utilService.showSnackbar('Assignee removed.', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
					this.sharedService.sendCarrierAssignedEvent({
						deleted: true,
						carrierId: carrierId,
					});
					this.userCarrierMapList = this.userCarrierMapList.filter(
						(cMap: any) => cMap.carrierId != carrierId
					);
				},
				(error) => {
					this.utilService.showSnackbar(
						'Unable to delete Assignee. Please try again.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
				}
			);
	}

	isFrequencyValidNumber(frequency): boolean {
		return !/\D/.test(frequency);
	}

	getCcScoreDisplay(accountCarrierMaps: AccountCarrierMapDTO[], carrier: any) {
		if (!accountCarrierMaps || accountCarrierMaps.length === 0) {
			return null;
		}
		let score = null;
		const accountCarrierMap = accountCarrierMaps.find((acm) => acm.accountId === this.accountId);
		score = accountCarrierMap?.ccScore;
		if (
			IS_EMPTY(accountCarrierMap?.vettingOverallDisplay) &&
			IS_NOT_EMPTY(carrier.vettingOverallDisplay)
		) {
			score = carrier.ccScore;
		}
		return this.sharedService.getCarrierScoreToDisplay(score, carrier.active);
	}

	getAccountCarrierMap(accountCarrierMaps: AccountCarrierMapDTO[], carrier: any) {
		if (!accountCarrierMaps || accountCarrierMaps.length === 0) {
			return null;
		}
		return accountCarrierMaps.find((acm) => acm.accountId === this.accountId);
	}

	getVettingSourceId(accountCarrierMaps: AccountCarrierMapDTO[]): any {
		return accountCarrierMaps?.find((acm) => acm.accountId === this.accountId)?.vettingSourceId;
	}

	getVettingSource(accountCarrierMaps: AccountCarrierMapDTO[]): any {
		return accountCarrierMaps?.find((acm) => acm.accountId === this.accountId)?.vettingSource;
	}

	onProjectCarrierMapContact(projectCarrierMap): void {
		this.store.dispatch(
			PROJECT_CARRIER_MAP.SET.CONTACT_UPDATE({ projectCarrierMap: projectCarrierMap })
		);
		this.setSelectedProjectCarrierMap(projectCarrierMap);
	}

	async setSelectedProjectCarrierMap(projectCarrierMap: ProjectCarrierMapDTO) {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let selectPcm = null;
				if (projectCarrierMap) {
					selectPcm = state.allProjectCarrierMapsList.find(
						(pcm) => pcm.id === projectCarrierMap.id
					);
				}
				this.selectedProjectCarrierMap = of(selectPcm);
			});
	}

	calculateViewportSize() {
		setTimeout(() => {
			this.viewports.forEach((viewport) => viewport.checkViewportSize());
		}, 0);
	}

	trackByFn(index: number, item: any): string {
		return item.id;
	}

	emitEditAllocationEvent(projectCarrierMap: ProjectCarrierMapDTO, event: MouseEvent): void {
		event.stopPropagation();
		this.editAllocationEvent.emit({ projectCarrierMap });
	}

	/**
	 * Get the allocation for a carrier if it exists
	 */
	getCarrierAllocation(carrierId: string): AllocationStatusDTO | null {
		return this.carrierAllocationsMap?.[carrierId] || null;
	}

	/**
	 * Check if a carrier has an active allocation
	 */
	hasActiveAllocation(carrierId: string): boolean {
		const allocation = this.getCarrierAllocation(carrierId);
		return allocation?.enabled === true;
	}

	/**
	 * Get a human-readable allocation summary
	 */
	getAllocationSummary(carrierId: string): string {
		const allocation = this.getCarrierAllocation(carrierId);

		if (!allocation) {
			return '';
		}

		const type = allocation.allocationType === 'PERCENTAGE' ? '%' : ' loads';
		const period = allocation.allocationPeriod?.toLowerCase() || 'period';
		return `${allocation.allocationValue}${type} ${period}`;
	}

	/**
	 * Get the allocation window info
	 */
	getAllocationWindow(carrierId: string): string {
		const allocation = this.getCarrierAllocation(carrierId);

		if (!allocation?.allocationWindowMinutes) {
			return '';
		}

		return `${allocation.allocationWindowMinutes} min window`;
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
}
